<template>
  <custom-page-form mode="edit" />
</template>

<script>
import CustomPageForm from "./CustomPageForm.vue";

export default {
  components: { CustomPageForm },
};
</script>
